
import homeBox from "@/components/Home/homeBox1.vue";
import { StoreTypes } from "@/assets/js/Types";
import Vue from "vue";
export default Vue.extend({
  components: { homeBox },
  data() {
    return {
      menu: [] as any[],
      userInfo: {} as any,
      side: [] as any,
      menus: {} as any,
    };
  },
  mounted() {
    this.userInfo = this.$store.state.project[StoreTypes.XC_USERINFO];
    this.init();
  },
  watch: {
    $route(to, from) {
      this.init();
      this.userInfo = this.$store.state.project[StoreTypes.XC_USERINFO];
    },
  },
  methods: {
    init() {
      const project = this.$store.state.project[StoreTypes.XC_PROJECT_CURRENT];
      if (project) {
        if (project.sid == "2026072708365582733200727557b4844") {
          this.menus.childrens = [];
          project.menu.childrens.forEach((m: any) => {
            if (m.sid != "20220826120111251266004053e38d122") {
              this.menus.childrens?.push(m);
            }
          });
        } else {
          this.menus = project.menu;
          this.menus.childrens = this.menus.childrens.filter(
            (item: any) => item.showInLine == 0
          );
        }
      }
      var m = this.menus.childrens;
      if (m.length == 0) {
        // window.location.reload();
        const routeObj = this.$router.resolve({
          path: "/Admin",
          // query: { sid: 'xxx' } // 需要参数直接写这里
        });
        window.open(routeObj.href, "_blank");
      }
      var side = [];
      var data = [];
      // var x1s=['029','021','']
      for (var i = 0; i < m.length; i++) {
        var isSider = false;
        var cls = "homex5";
        if (
          m[i].sid == "2022082612011125135200405267094f48" ||
          "2022082612011125135200405267094f44" == m[i].sid
        ) {
          cls = "homex5x2 ";
          // isSider = true;
        }
        let obj: any = this.getColors(m[i].Path);
        if (obj.random || !obj.color.pic) {
          obj.color.pic = m[i].menuPic;
        }
        obj.cls = cls;
        obj.title = m[i].menuName;
        obj.index = i;
        obj.path = m[i].path;
        if (!isSider) {
          data.push(obj);
        } else {
          side.push(obj);
        }
      }
      this.side = side;
      this.menu = data;
    },
    getColors(path: any) {
      var array = [
        {
          path: "/Admin/Cam",
          start: "#1247D1",
          end: "#0335A6",
        },
        {
          path: "/Admin/Broad",
          start: "#FBB166",
          end: "#F76C41",
        },
        {
          path: "/Admin/Stand",
          start: "#496DEF",
          end: "#1536B0",
        },
        {
          path: "/Admin/Light",
          start: "#1247D1",
          end: "#0335A6",
        },
        {
          path: "/Admin/Sensor",
          start: "#65DD6F",
          end: "#3EA844",
        },
        {
          path: "/Admin/Led",
          start: "#1C81D9",
          end: "#1362E5",
        },
        {
          path: "/Admin/OView",
          start: "#1C81D9",
          end: "#1362E5",
        },
        {
          path: "/Admin/Wifi",
          start: "#1C81D9",
          end: "#1362E5",
        },
        {
          path: "/Admin/Water",
          start: "#1C81D9",
          end: "#1362E5",
        },
        {
          path: "/Admin/Conver",
          start: "#1247D1",
          end: "#0335A6",
        },
        {
          path: "/Admin/Car",
          start: "#3AC4F5",
          end: "#218FF0",
        },
        {
          path: "/Admin/Alarms",
          start: "#F55754",
          end: "#F44647",
        },
        {
          path: "/Admin/Face",
          start: "#1247D1",
          end: "#0335A6",
        },
        {
          path: "/Home",
          start: "#686AF4",
          end: "#3C3CC0",
        },
        {
          path: "/Admin/XiXun",
          start: "#55A658",
          end: "#55A658",
        },
        {
          path: "/Admin/Hydrant",
          start: "#DF4C56",
          end: "#DF4C56",
        },
        {
          path: "/Admin/Nova",
          start: "#FBB166",
          end: "#F76C41",
        },
        {
          path: "/Admin/NovaBroad",
          start: "#D67048",
          end: "#D67048",
        },
        {
          path: "/Admin/NwLed",
          start: "#55A658",
          end: "#55A658",
        },
      ];
      var obj = null;
      if (obj) {
        return {
          color: obj,
          random: false,
        };
      } else {
        return {
          color: array[Math.round(Math.random() * 18)],
          random: true,
        };
      }
    },
  },
});
